import React from 'react';

import classNames from 'classnames';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import { FormattedMessage } from 'react-intl';

import messages from './FormField.messages';
import Header from './Header';
import Input from './Input';
import Multiple from './Multiple';
import Select from './Select';
import InputTooltip from '../InputTooltip/InputToolTip';

class FormField extends React.PureComponent {
    static Select = Select;
    static Input = Input;
    static Multiple = Multiple;
    static Header = Header;

    static defaultProps = {
        wrapperClass: '',
        wrapperGrid: {
            xs: 12,
            sm: 6
        },
        optional: false,
        subText: null,
        tooltip: null
    };

    constructor() {
        super();
        this.renderTooltip = this.renderTooltip.bind(this);
    }

    renderTooltip() {
        const { tooltip } = this.props;
        return tooltip ? <InputTooltip overlayText={tooltip} /> : null;
    }

    render() {
        const {
            field,
            label,
            labelProps = {},
            wrapperGrid,
            wrapperClassName,
            optional,
            subText,
            children,
            customErrorMessage,
            overriddenErrorMessage
        } = this.props;
        const error =
            overriddenErrorMessage || field.error || customErrorMessage;

        return (
            <Col
                {...wrapperGrid}
                className={classNames(wrapperClassName, {
                    invalid: field.touched && error
                })}>
                <ControlLabel {...labelProps}>
                    {label}
                    {optional && (
                        <FormattedMessage {...messages.optional}>
                            {(message) => (
                                <span className="helper"> ({message})</span>
                            )}
                        </FormattedMessage>
                    )}
                    {this.renderTooltip()}
                </ControlLabel>
                {error ? (
                    typeof error === 'string' ? (
                        <span
                            data-testid={`${field.name}-error`}
                            className="error">
                            <FormattedMessage
                                id={error}
                                defaultMessage={error}
                            />
                        </span>
                    ) : (
                        <span
                            data-testid={`${field.name}-error`}
                            className="error">
                            {error}
                        </span>
                    )
                ) : null}
                {React.cloneElement(children, { field })}
                {subText ? (
                    <div className="toggle-role"> {subText} </div>
                ) : null}
            </Col>
        );
    }
}

export default FormField;
